module.exports = __webpack_public_path__ + "static/media/craft-09.6bb54afb.svg";